import { EditCommand } from "./EditCommand";

export abstract class AbstractAddValueToArrayCommand<TSource, TValue> extends EditCommand<TSource, number> implements IIndexSpecifiable {
  constructor(private readonly _value: TValue, index?: number) {
    super(
      s => ((index !== null) && (index !== undefined)) ? index : this.readArray(s).length,
      s => {
        const array = this.readArray(s);
        array.splice(((index !== null) && (index !== undefined)) ? index : array.length, 0, this._value);
      },
      (s, b) => this.readArray(s).splice(b, 1)
    );
  }

  public setIndex(index: number): void {
    this.restructure(
      s => ((index !== null) && (index !== undefined)) ? index : this.readArray(s).length,
      s => {
        const array = this.readArray(s);
        array.splice(((index !== null) && (index !== undefined)) ? index : array.length, 0, this._value);
      },
      (s, b) => this.readArray(s).splice(b, 1)
    );
  }

  protected abstract readArray(source: TSource): TValue[];
}

export interface IIndexSpecifiable {
  setIndex(index: number): void;
}

export function instanceOfIIndexSpecifiable(instance: any): instance is IIndexSpecifiable {
  return instance
      && (instance.setIndex !== undefined);
}

